import '../sass/serie.sass';

document.addEventListener("DOMContentLoaded", () => {

    /* -----------------------------
       Event Delegation (body)
    ----------------------------- */

    document.body.addEventListener("click", (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        
        /* -----------------------------
        Close TVOD popup
        ----------------------------- */
        const closeBtn = target.closest(".series-tvod__close") as HTMLElement | null;
        if (closeBtn) {
            event.preventDefault();
            
            const container = document.querySelector<HTMLElement>(".series-tvod__container");
            if (container) {
                container.style.display = "none";
            }
            
            return; // Stop further checks
        }
        
        const episode = target.closest('.carousel__slide')
        const image = target.closest('.episode__image_container')

        if (episode && image) {
            const episodeBtn = episode.querySelector('.see-serie-tvod-btn') as HTMLElement | null;
            if (!episodeBtn || !episodeBtn.dataset.href) return
            event.preventDefault()
            ajaxSerieTvodOffer(episodeBtn.dataset.href)
            return
        }

        /* -----------------------------
        Open TVOD popup (AJAX offer)
        ----------------------------- */
        const tvodBtn = target.closest(".see-serie-tvod-btn") as HTMLElement | null;
        if (tvodBtn) {
            event.preventDefault();

            const href = tvodBtn.dataset.href;

            ajaxSerieTvodOffer(href);
        }
    });


    /* -----------------------------
       AJAX: Load TVOD Offer
    ----------------------------- */

    function ajaxSerieTvodOffer(url: string): void {
        fetch(url, { method: "GET" })
            .then(res => res.text())
            .then((html: string) => {
                const offers = document.querySelector<HTMLElement>(".offers");
                if (offers) {
                    offers.innerHTML = html;
                }
            })
            .catch(err => {
                console.error("TVOD AJAX error:", err);
            });
    }

});
